import { UserProfile } from 'oidc-client-ts';

export function GetAccountId(auth: UserProfile | undefined): string {
  return `${auth?.account_number}`;
}
export function GetSocketSessionId(auth: UserProfile | undefined): string {
  return GetAccountId(auth);
}
